import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Stethoscope, Scissors, Utensils, ArrowRight, ShieldCheck } from "lucide-react";

export default function PartnerPortal() {
    return (
        <div data-testid="partner-portal">
            <div className="bg-[var(--rl-cream)] border-b border-[var(--rl-border)]">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-2 gap-10 items-center">
                    <div>
                        <div className="eyebrow mb-3">Partner Portal</div>
                        <h1 className="font-serif text-4xl lg:text-6xl tracking-tight">For vets, groomers,<br />and food providers.</h1>
                        <p className="mt-4 text-[var(--rl-text-2)] max-w-md">Join the rescue supply chain. Offer discounted services or donate product — reach thousands of adopters and lifelong customers.</p>
                        <div className="mt-6 flex flex-wrap gap-3">
                            <Link to="/auth?role=partner"><Button className="btn-primary rounded-full h-11 px-5" data-testid="become-partner-btn">Become a partner</Button></Link>
                            <Link to="/services"><Button variant="outline" className="rounded-full h-11 px-5 border-[var(--rl-border-strong)]">See existing partners</Button></Link>
                        </div>
                    </div>
                    <div className="rounded-2xl overflow-hidden border border-[var(--rl-border)]">
                        <img src="https://images.pexels.com/photos/6235238/pexels-photo-6235238.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                             alt="Vet with dog" className="w-full aspect-[4/3] object-cover" />
                    </div>
                </div>
            </div>

            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14">
                <h2 className="font-serif text-3xl mb-8">What partners provide</h2>
                <div className="grid md:grid-cols-3 gap-6">
                    <Category icon={<Stethoscope className="w-5 h-5" />} title="Veterinary care" body="Spay/neuter, vaccinations, heartworm treatment, and emergency care at rescue-partner rates." />
                    <Category icon={<Scissors className="w-5 h-5" />} title="Grooming" body="First-bath services for shelter intakes and discounted grooming for foster homes." />
                    <Category icon={<Utensils className="w-5 h-5" />} title="Food & supplies" body="Bulk donations of kibble, wet food, treats, and enrichment for network fosters." />
                </div>
            </section>

            <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">
                <div className="card-warm rounded-2xl p-10 grid lg:grid-cols-2 gap-8 items-center">
                    <div>
                        <ShieldCheck className="w-10 h-10 text-[var(--rl-success)]" />
                        <h3 className="font-serif text-3xl mt-3">The Partner Promise</h3>
                        <p className="mt-3 text-[var(--rl-text-2)]">Verified partners are featured across the network with a "Rescue Partner" badge, referral traffic from adopters, and access to a private coordinator channel.</p>
                    </div>
                    <div>
                        <ul className="space-y-2 text-sm">
                            <li>✓ Featured badge across all directories</li>
                            <li>✓ Direct referrals from adopters and fosters</li>
                            <li>✓ Access to bulk purchase group</li>
                            <li>✓ Co-marketing on RescueLink social channels</li>
                            <li>✓ Simple monthly reporting dashboard</li>
                        </ul>
                        <Link to="/auth?role=partner" className="inline-flex items-center gap-1.5 mt-6 text-sm font-semibold text-[var(--rl-primary)]">
                            Apply to join <ArrowRight className="w-4 h-4" />
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}

function Category({ icon, title, body }) {
    return (
        <div className="card-warm rounded-xl p-6">
            <div className="w-10 h-10 rounded-full bg-[var(--rl-cream)] flex items-center justify-center mb-4">{icon}</div>
            <h3 className="font-serif text-2xl">{title}</h3>
            <p className="text-sm text-[var(--rl-text-2)] mt-2">{body}</p>
        </div>
    );
}
